import { type RumErrorFilterRule } from './utils';

export const rumErrorFilterRules: RumErrorFilterRule[] = [
  {
    name: 'generic-browser-script-error',
    source: 'source',
    sourceType: 'browser',
    messageIncludes: ['Script error.'],
  },
  {
    name: 'ignored-touchmove-cancel-report',
    source: 'report',
    sourceType: 'browser',
    errorType: 'IgnoredEventCancel',
    messageIncludes: ['Ignored attempt to cancel a touchmove event'],
  },
  {
    name: 'ignored-touchstart-cancel-report',
    source: 'report',
    sourceType: 'browser',
    errorType: 'IgnoredEventCancel',
    messageIncludes: ['Ignored attempt to cancel a touchstart event'],
  },
  {
    name: 'snowplow-localstorage-quota-exceeded',
    source: 'console',
    sourceType: 'browser',
    errorType: 'QuotaExceededError',
    messageIncludes: ['Failed to persist events to localStorage', 'QuotaExceededError'],
  },
  {
    name: 'snowplow-localstorage-security-error',
    source: 'console',
    sourceType: 'browser',
    errorType: 'SecurityError',
    fileIncludes: ['@snowplow+browser-tracker-core', 'local_storage_event_store.ts'],
    messageIncludes: ['Failed to persist events to localStorage', 'The operation is insecure'],
  },
  {
    name: 'snowplow-localstorage-initialization-security-error',
    source: 'console',
    sourceType: 'browser',
    errorType: 'SecurityError',
    fileIncludes: ['@snowplow+browser-tracker-core', 'local_storage_event_store.ts'],
    messageIncludes: ['Failed to access localStorage when initializing event store', 'The operation is insecure'],
  },
  {
    name: 'didomi-ui-chunk-load-failed',
    source: 'source',
    sourceType: 'browser',
    errorType: 'ChunkLoadError',
    messageIncludes: ['Loading chunk ui-web-', 'sdk.privacy-center.org/sdk/', '/modern/ui-web-'],
  },
  {
    name: 'gtm-tracking-load-failed',
    source: 'console',
    sourceType: 'browser',
    errorType: 'TypeError',
    handlingStackIncludes: ['gtm-tracking.engelvoelkers.com/dist/bundle.umd.min.js'],
    message: 'TypeError: Load failed',
  },
  {
    name: 'gtm-tracking-fetch-failed',
    source: 'console',
    sourceType: 'browser',
    errorType: 'TypeError',
    handlingStackIncludes: ['gtm-tracking.engelvoelkers.com/dist/bundle.umd.min.js'],
    message: 'TypeError: Failed to fetch',
  },
  {
    name: 'gtm-tracking-storage-security-error',
    source: 'console',
    sourceType: 'browser',
    errorType: 'SecurityError',
    message: 'SecurityError: The operation is insecure.',
    stackIncludes: ['gtm-tracking.engelvoelkers.com/dist/bundle.umd.min.js'],
  },
  {
    name: 'chrome-extension-m-id-undefined',
    source: 'source',
    sourceType: 'browser',
    errorType: 'TypeError',
    message: "Cannot read properties of undefined (reading 'M_ID')",
    stackIncludes: ['chrome-extension://eppiocemhmnlbhjplcgkofciiegomcon/executors/200.js'],
  },
  {
    name: 'circular-json-stringify-console-error',
    source: 'console',
    sourceType: 'browser',
    errorType: 'TypeError',
    messageIncludes: ['Converting circular structure to JSON'],
    messageRegex: /HTMLAnchorElement|__reactFiber\$/,
  },
  {
    name: 'resize-observer-undelivered-notifications',
    source: 'source',
    sourceType: 'browser',
    messageIncludes: ['ResizeObserver loop completed with undelivered notifications'],
  },
  {
    name: 'maplibre-fetch-aborted',
    source: 'source',
    sourceType: 'browser',
    errorType: 'AbortError',
    fileIncludes: ['maplibre-gl', 'src/util/actor.ts'],
    messageIncludes: ['Fetch is aborted'],
  },
  {
    name: 'maptiler-leaflet-remove-after-teardown',
    sourceType: 'browser',
    errorType: 'TypeError',
    fileIncludes: ['@maptiler+leaflet-maptilersdk', 'leaflet-maptilersdk.ts'],
    messageIncludes: ["Cannot read properties of undefined (reading 'remove')"],
  },
  {
    name: 'electron-injected-floor-plan-error',
    source: 'source',
    sourceType: 'browser',
    errorType: 'TypeError',
    message: 'data.floorPlanImages is not iterable',
    stackIncludes: ['IpcRenderer.emit', 'node:events'],
  },
  {
    name: 'google-app-injected-recursion',
    source: 'source',
    sourceType: 'browser',
    errorType: 'RangeError',
    message: 'Maximum call stack size exceeded.',
    stackIncludes: ['at Hk @ https://www.engelvoelkers.com/', 'at Fk @ https://www.engelvoelkers.com/'],
    userAgentIncludes: ['GSA/'],
  },
  {
    name: 'duckduckgo-ios-invalid-origin',
    source: 'source',
    sourceType: 'browser',
    errorType: 'Error',
    message: 'invalid origin',
    stackIncludes: ['Error: invalid origin'],
    userAgentIncludes: ['DuckDuckGo'],
  },
  {
    name: 'instagram-ios-bridge-message-handlers',
    source: 'source',
    sourceType: 'browser',
    errorType: 'TypeError',
    messageIncludes: ['window.webkit.messageHandlers'],
    userAgentIncludes: ['Instagram'],
    userAgentRegex: /(iPad|iPhone|iPod)/i,
  },
  // https://github.com/react/react/issues/34053#issuecomment-4929193561
  {
    name: 'instagram-android-java-object-gone',
    source: 'source',
    sourceType: 'browser',
    errorType: 'Error',
    messageIncludes: ['Java object is gone'],
  },
  {
    name: 'meta-android-postmessage-java-exception',
    source: 'source',
    sourceType: 'browser',
    errorType: 'Error',
    message: 'Error invoking postMessage: Java exception was raised during method invocation',
  },
];
